import {
  getApiV1ThreeLetterCodePartnerAdminsGroups,
  getGetApiV1ThreeLetterCodePartnerAdminsGroupsKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodePartnerAdminsGroups200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';
import { KeyedMutator } from 'swr';

type Args = {
  /** 3文字コード */
  threeLetterCode: string;
};

type ReturnType = {
  /** グループ一覧データ */
  data: GetApiV1ThreeLetterCodePartnerAdminsGroups200;
  /** データ再取得関数 */
  mutate: KeyedMutator<GetApiV1ThreeLetterCodePartnerAdminsGroups200>;
  /** ローディング状態 */
  isLoading: boolean;
};

/**
 * useGetPartnerAdminsGroupsフックの型定義
 */
type IUseGetPartnerAdminsGroups = (args: Args) => ReturnType;

/**
 * パートナー管理者用グループ一覧取得フック
 */
export const useGetPartnerAdminsGroups: IUseGetPartnerAdminsGroups = ({ threeLetterCode }) => {
  const { data, mutate, isLoading } = useFetch(
    getGetApiV1ThreeLetterCodePartnerAdminsGroupsKey(threeLetterCode),
    () => getApiV1ThreeLetterCodePartnerAdminsGroups(threeLetterCode),
    { suspense: true }
  );

  return {
    data,
    mutate,
    isLoading,
  };
};
